import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { useViewTableMeta } from "@hooks/view/useViewTableMeta";
import { ServiceTemplateScheduleRow } from "../serviceTemplateSchedulesViewConfig";
import {
    ServiceTemplateScheduleCallbacks,
    ServiceTemplateScheduleTableOptions,
} from "../ServiceTemplateSchedulesList";
import styles from "./ServiceTemplateScheduleTemplateNameCell.module.scss";

export const ServiceTemplateScheduleTemplateNameCell = memo(
    ({
        row,
        table,
    }: CellContext<ViewTableFeatures, ServiceTemplateScheduleRow, string>) => {
        const { templateId } = row.original;
        const meta = useViewTableMeta<
            ServiceTemplateScheduleCallbacks,
            ServiceTemplateScheduleTableOptions
        >(table);

        // Names are resolved from a single lookup map built once by the list
        // component (including archived templates), so each row avoids
        // re-subscribing to `useCloseTemplates` (see PRO-10571).
        // No ViewTableCell wrapper: this column is the nesting expandColumn, so
        // ExpandCollapseCell already provides the cell chrome.
        const templateName =
            meta.options?.templateNameById?.get(templateId) ?? "-";

        return <span className={styles.name}>{templateName}</span>;
    },
);

ServiceTemplateScheduleTemplateNameCell.displayName =
    "ServiceTemplateScheduleTemplateNameCell";
